// angular
import { Routes } from '@angular/router';
// layout
import { ProfileLayoutComponent } from './profile-layout/profile-layout.component';
// pages
import { ProfileCommentsComponent } from './profile-comments/profile-comments.component';
// roles & guard
import { RoleGuard } from '@app/guards/role.guard';
import { Roles } from '@app/shared/enums/roles.enum';

export const ProfileRoutes: Routes = [
  {
    path: '',
    component: ProfileLayoutComponent,
    children: [
      {
        path: 'favorites',
        loadChildren: () =>
          import('./profile-favorites/favorite.routes').then(
            m => m.FavoritesRoutes
          ),
      },
      {
        path: 'comments',
        component: ProfileCommentsComponent,
        data: { titleKey: 'routes.comments' },
      },
    ],
    data: { roles: [Roles.ViewPeopleSelf] },
    canActivate: [RoleGuard],
  },
];
